import React, { Component } from 'react'
import styles from './Footer.module.css'
import { MdEmail } from 'react-icons/md';
import { AiFillGithub } from 'react-icons/ai';
import { GrLinkedinOption } from 'react-icons/gr';
import { RiCodepenFill } from 'react-icons/ri';
import { SiFreecodecamp } from 'react-icons/si';

export class Footer extends Component {
  render() {
    return (
      <div className={styles.footer}>
        <div className={styles.footerDiv}>&#169; 2022 Devansh Bharadwaj</div>
        <div className={styles.footerDiv}><MdEmail /><AiFillGithub /><GrLinkedinOption /><RiCodepenFill /><SiFreecodecamp /></div>
      </div>
    )
  }
}

export default Footer